
import { useState } from "react";

import "./PrepList.css";


import Unipage from "../templates/Unipage";

function Selector(props) {
    return (<>
        <h4>{props.name}</h4>
        { 
            props.choices.map(
                (item, index) => {
                    if (props.getVal() === item) {
                        return <button className="selected" onClick={() => props.setVal(item)}>{item}</button>
                    }
                    else {
                        return <button className="notSelected" onClick={() => props.setVal(item)}>{item}</button>
                    }
                }
            )
        }
    </>);
}

export default function PrepList() {

    const [dayOfWeek, setDayOfWeek] = useState(null);

    const [garOil, setGarOil] = useState(null);

    return (<Unipage
        content={
            <>
                <h2>Prep List</h2>

                <Selector name="Day of Week" choices={["M/Tu", "W/Th", "F/Sa", "Su"]} getVal={() => dayOfWeek} setVal={setDayOfWeek} />

                <h3>Makeline</h3>

                <h3>Cut Table</h3>
                <Selector name="Garlic Oil" choices={["0", "1-2", "3-4", "5-6", "7+"]} getVal={() => garOil} setVal={setGarOil}  />

            </>
        }
    />);

}